import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b00575cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Filtro de datas", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Selecione o mês/ano ou período desejado", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-text" }, "Mês Atual", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-text" }, "Mês Passado", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-text" }, "Metas fechadas", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limpar", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Aplicar", -1))

import { onMounted, computed, watch, withDefaults } from 'vue';
import { ref } from 'vue';
import { AtomButton } from '@/components/atoms';
import { MoleculeCard, MoleculeFunctionFilter, MoleculeTabsDate } from '.'
import type { ITab } from '@/types';
import { format, addMonths } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface IProps {
  isGoalClosed: boolean
  isRoles: boolean
  isGoal?: boolean
  isCollaborator?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeDataFilter',
  props: {
    isGoalClosed: { type: Boolean, default: true },
    isRoles: { type: Boolean, default: true },
    isGoal: { type: Boolean, default: false },
    isCollaborator: { type: Boolean, default: false }
  },
  emits: ['handleFilter', 'handleCancel', 'handlePreview'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const dayNames = ref(['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'])
const location = ref(ptBR);
const emit = __emit;
const roleId = ref<number>(0)
const goalClosed = ref<boolean>(false);
const activeYear = ref<string>('');
const clear = ref<boolean>(false);
const monthOld = ref<Date>(new Date());
const monthActual = ref<Date>(new Date());
const tabsYear = ref<ITab[]>([
  {
    label: '2022',
    value: '2022',
  },

]);
const activeMonth = ref<string>('');
const tabsMonths = ref<ITab[]>([
  {
    label: 'Jan',
    value: '1',
  },
  {
    label: 'Fev',
    value: '2',
  },
  {
    label: 'Mar',
    value: '3',
  },
  {
    label: 'Abr',
    value: '4',
  },
  {
    label: 'Mai',
    value: '5',
  },
  {
    label: 'Jun',
    value: '6',
  },
  {
    label: 'Jul',
    value: '7',
  },
  {
    label: 'Ago',
    value: '8',
  }
  ,
  {
    label: 'Set',
    value: '9',
  }
  ,
  {
    label: 'Out',
    value: '10',
  }
  ,
  {
    label: 'Nov',
    value: '11',
  }
  ,
  {
    label: 'Dez',
    value: '12',
  }
]);
const customPosition = () => ({ top: -1, left: -5 });
const customPositionUntil = () => ({ top: -1, left: -5 });
function handleGoalClosed() {
  goalClosed.value = !goalClosed.value;
  // if (goalClosed.value) {
  //   activeMonth.value = '';
  //   activeYear.value = '';
  // } else {
  //   handleMonthActual();
  // }
}
function handleFilter() {
  if (props.isCollaborator) {
    emit('handleFilter', { date: date.value });
  }
  else if (!props.isGoal) {
    emit('handleFilter', { role_id: roleId.value, date: goalClosed.value ? undefined : date.value, goalClosed: goalClosed.value })
  } else {
    emit('handleFilter', { role_id: roleId.value, start_date: monthOld.value, end_date: monthActual.value, goalClosed: goalClosed.value })
  }
}
function handleRoles(event: number) {
  roleId.value = event;
}
const date = computed(() => {
  const date = (!!activeYear.value && !!activeMonth.value) ?
    `${activeYear.value}-${activeMonth.value.padStart(2, '0')}-01T00:00:00`
    : undefined
  return date ? new Date(date) : new Date();
})
function handleMonthActual() {
  activeYear.value = `${monthActual.value?.getFullYear()}`;
  activeMonth.value = `${monthActual.value?.getMonth() + 1}`;
}
function handleMonthOld() {
  activeYear.value = `${monthOld.value?.getFullYear()}`;
  activeMonth.value = `${monthOld.value?.getMonth() + 1}`;
}
function handleClear() {
  clear.value = true;
  activeMonth.value = '';
  activeYear.value = '';

  if (props.isGoal) {
    monthActual.value = undefined;
    monthOld.value = undefined;
    goalClosed.value = false;
  }
  emit('handleFilter', {})
}

const isOldMonth = computed(() => {
  return format(date.value, 'yyyy-MM-dd') == format(monthOld.value, 'yyyy-MM-dd')
})

const isActualMonth = computed(() => {
  return format(date.value, 'yyyy-MM-dd') == format(monthActual.value, 'yyyy-MM-dd')
})
onMounted(() => {
  const date = new Date();
  const dataFormat = format(date, 'yyyy-MM-01 00:00:00')
  monthActual.value = new Date(dataFormat);
  monthOld.value = addMonths(monthActual.value, -1);
  const yearInitial = date.getFullYear() - Number(tabsYear.value[0].value);

  if (yearInitial > 1) {

    for (let index = 1; index <= yearInitial; index++) {

      tabsYear.value.push({
        label: `${Number(tabsYear.value[0].value) + index}`,
        value: `${Number(tabsYear.value[0].value) + index}`,
      })

    }
  }

  tabsYear.value = [...tabsYear.value,
  // {
  //   label: `${date.getFullYear()}`,
  //   value: `${date.getFullYear()}`,
  // },
  {
    label: `${date.getFullYear() + 1}`,
    value: `${date.getFullYear() + 1}`,
  }]

  activeMonth.value = `${date.getMonth() + 1}`;
  activeYear.value = `${date.getFullYear()}`;

  if (props.isGoal) {
    monthActual.value = undefined;
    monthOld.value = undefined;
  }
})

watch(() => date.value,
  () => {
    emit("handlePreview", date.value);
  })

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_card_item = _resolveComponent("v-card-item")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), { class: "width-card w-100" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pb-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "pt-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (props.isCollaborator)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "px-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MoleculeTabsDate), {
                        modelValue: activeYear.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeYear).value = $event)),
                        tabs: tabsYear.value
                      }, null, 8, ["modelValue", "tabs"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_col, { class: "px-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MoleculeTabsDate), {
                        modelValue: activeMonth.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeMonth).value = $event)),
                        tabs: tabsMonths.value
                      }, null, 8, ["modelValue", "tabs"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (!props.isGoal)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AtomButton), {
                        background: "transparent",
                        class: _normalizeClass(["btn-border text-bold w-100 text-sm pa-1 my-1", { active: isActualMonth.value }]),
                        onClick: handleMonthActual
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_unref(AtomButton), {
                        background: "transparent",
                        class: _normalizeClass(["btn-border text-bold w-100 text-sm pa-1 my-1", { active: isOldMonth.value }]),
                        onClick: handleMonthOld
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.isGoal)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 1,
                    cols: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VueDatePicker, {
                        modelValue: monthOld.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((monthOld).value = $event)),
                        "month-picker": "",
                        placeholder: "De:",
                        "format-locale": location.value,
                        "enable-time-picker": false,
                        "day-names": dayNames.value,
                        "auto-apply": "",
                        "model-type": "yyyy-MM-dd",
                        locale: "pt-BR",
                        "alt-position": customPosition
                      }, null, 8, ["modelValue", "format-locale", "day-names"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.isGoal)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 2,
                    cols: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VueDatePicker, {
                        modelValue: monthActual.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((monthActual).value = $event)),
                        "month-picker": "",
                        placeholder: "Até:",
                        "format-locale": location.value,
                        "enable-time-picker": false,
                        "day-names": dayNames.value,
                        "auto-apply": "",
                        "model-type": "yyyy-MM-dd",
                        locale: "pt-BR",
                        "alt-position": customPositionUntil
                      }, null, 8, ["modelValue", "format-locale", "day-names"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.isRoles)
                ? (_openBlock(), _createBlock(_component_v_divider, { key: 3 }))
                : _createCommentVNode("", true),
              (props.isGoal)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 4,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      (props.isGoalClosed)
                        ? (_openBlock(), _createBlock(_unref(AtomButton), {
                            key: 0,
                            background: "transparent",
                            class: _normalizeClass(["btn-border text-bold w-100 text-sm pa-1 my-1", { active: goalClosed.value }]),
                            onClick: handleGoalClosed
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (props.isRoles)
                ? (_openBlock(), _createBlock(_component_v_divider, { key: 5 }))
                : _createCommentVNode("", true),
              (props.isRoles)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 6,
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MoleculeFunctionFilter), {
                        onHandleFilter: handleRoles,
                        "is-card": false,
                        clear: clear.value,
                        onHandleCancel: _cache[4] || (_cache[4] = ($event: any) => (clear.value = !$event))
                      }, null, 8, ["clear"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    class: "btn-border text-bold w-100 text-sm pa-1 my-1",
                    onClick: handleClear
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    class: "text-bold w-100 text-sm pa-1 my-1 btn-submit",
                    onClick: handleFilter
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})